import React from 'react';

export default function TermsOfService({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[1100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div 
        className="w-full max-w-3xl bg-gray-800 rounded-xl shadow-2xl overflow-hidden border border-gray-700 flex flex-col max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-700 bg-gray-800/80">
          <h2 className="text-xl font-bold text-gray-100">
            Alffy User Agreement & Terms of Service
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white text-xl leading-none transition-colors"
            title="Close"
          >
            ✕
          </button>
        </div>
        
        <div className="p-6 overflow-y-auto">
          <div className="space-y-6 text-xs md:text-sm leading-relaxed text-gray-300">
            <section>
              <h3 className="font-semibold text-white mb-2">1. Acceptance of Terms</h3>
              <p>
                By accessing, browsing, or using the Alffy application ("the Service"), you represent 
                that you have read, understood, and agree to be bound by this User Agreement. If you 
                do not agree to these terms, you must not use or access the Service.
              </p>
            </section>

            <section className="bg-red-900/20 border-l-4 border-red-500 p-3 rounded-r-lg">
              <h3 className="font-semibold text-red-400 mb-2 uppercase tracking-wider text-[10px] md:text-xs">
                Important Disclaimer: Not Investment Advice
              </h3>
              <p className="font-medium text-white mb-1">
                This site does NOT provide investment advice.
              </p>
              <p>
                All content, data, AI summaries, text, and financial information provided by Alffy is 
                for informational and educational purposes only. It does not constitute financial, 
                investment, legal, or tax advice. Please consult your professional, registered 
                investment advisor or financial planner before making any financial or investment 
                decisions. Alffy and its creators are not liable for any financial losses or damages 
                incurred as a result of using our tools or inferring conclusions from our data.
              </p>
            </section>

            <section className="bg-yellow-900/20 border-l-4 border-yellow-500 p-3 rounded-r-lg">
              <h3 className="font-semibold text-yellow-400 mb-2 uppercase tracking-wider text-[10px] md:text-xs">
                Artificial Intelligence (AI) Disclaimer
              </h3>
              <p>
                Certain features of Alffy, such as earnings call summaries and MD&A analyses, are 
                generated by Artificial Intelligence large language models. While AI is a powerful tool, 
                <strong> AI can make mistakes or sometimes hallucinate.</strong> The AI-generated content 
                may omit critical context, misinterpret financial nuances, or present factually inaccurate 
                statements. Users are strictly advised to independently verify all AI-generated statements 
                by reviewing the original source filings (e.g., 10-K, 10-Q, transcript). You agree that 
                you will not base any automated trading logic or critical investment decisions solely on 
                our AI-generated outputs.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-white mb-2">2. Data Accuracy and Availability</h3>
              <p>
                Although we make every effort to keep our data accurate, the quality of financial data 
                greatly depends on many third-party factors, upstream data providers, and SEC release 
                timings, and therefore <strong>cannot be guaranteed</strong>. Alffy provides data on an 
                "AS-IS" and "AS-AVAILABLE" basis without warranties of any kind, whether express or implied. 
                We do not warrant that the data is error-free, timely, or perfectly reliable.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-white mb-2">3. Limitation of Liability</h3>
              <p>
                To the maximum extent permitted by applicable law, in no event shall Alffy, its affiliates, 
                directors, employees, or developers be held liable for any direct, indirect, incidental, 
                special, or consequential damages (including, without limitation, damages for loss of profits, 
                data, or other intangible losses) arising out of or relating to your use or inability to use 
                the Service, or reliance on any information obtained from the Service. You explicitly waive 
                any right to bring a lawsuit or claim arising out of false/inaccurate claims, data delays, 
                or investment losses you attribute to the use of Alffy.
              </p>
            </section>

            <section>
              <h3 className="font-semibold text-white mb-2">4. Intellectual Property</h3>
              <p>
                Content presented on Alffy is aggregated from public sources, third-party APIs, and AI models. 
                The proprietary compilation, design, interface, and logic of Alffy remain the intellectual 
                property of its creators. You may not scrape, copy, or redistribute the internal workings 
                of the Service without prior written consent.
              </p>
            </section>
          </div>
        </div>
        
        <div className="px-6 py-4 border-t border-gray-700 bg-gray-800/80 flex justify-between items-center">
          <p className="text-[10px] text-gray-500">
            Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
          <button 
            onClick={onClose}
            className="px-4 py-1.5 bg-blue-600 hover:bg-blue-500 text-white text-sm font-medium rounded-lg transition-colors"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
}
